import { Component, Input } from '@angular/core';
import { InfosCarte } from 'src/app/api/model/infos-carte.model';

@Component({
  selector: 'app-info-carte',
  templateUrl: './info-carte.component.html',
  styleUrls: ['./info-carte.component.scss'],
  standalone: false,
})
export class InfoCarteComponent {
  @Input() infoCarte!: InfosCarte;

  constructor() {}
}
